(function () {
  "use strict";

  class BloodTransfusionCalculator extends HTMLElement {
    connectedCallback() {
      if (this.__bloodTransfusionInitialized) return;
      this.__bloodTransfusionInitialized = true;

      var root = this;

      var K = { dog: 90, cat: 60 };
        var species = root.dataset.defaultSpecies === 'cat' ? 'cat' : 'dog';

        var els = {
          weight: root.querySelector('#weight'),
          current: root.querySelector('#current'),
          desired: root.querySelector('#desired'),
          donor: root.querySelector('#donor'),
          result: root.querySelector('#result'),
          volume: root.querySelector('#volume'),
          note: root.querySelector('#note'),
          msg: root.querySelector('#msg'),
          breakdown: root.querySelector('#breakdown'),
          rise: root.querySelector('#rise'),
          perkg: root.querySelector('#perkg'),
          const: root.querySelector('#const'),
          formula: root.querySelector('#formula')
        };

        root.querySelectorAll('#species button').forEach(function(button){
          button.classList.toggle('active', button.getAttribute('data-species') === species);
        });

        root.querySelector('#species').addEventListener('click', function(e){
          var btn = e.target.closest('button');
          if(!btn) return;
          species = btn.getAttribute('data-species');
          root.querySelectorAll('#species button').forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          calc();
        });

        ['weight','current','desired','donor'].forEach(function(id){
          els[id].addEventListener('input', calc);
        });

        function num(v){ var n = parseFloat(v); return isNaN(n) ? null : n; }

        function setState(cls){
          els.result.classList.remove('warn','bad');
          if(cls) els.result.classList.add(cls);
        }

        function calc(){
          var w = num(els.weight.value);
          var cur = num(els.current.value);
          var des = num(els.desired.value);
          var don = num(els.donor.value);
          var k = K[species];

          els.msg.textContent = '';
          setState('');

          if(w === null || cur === null || des === null || don === null){
            els.volume.innerHTML = '— <span>mL</span>';
            els.note.textContent = 'Enter the values above';
            els.breakdown.style.display = 'none';
            return;
          }

          // validation
          if(w <= 0){ return invalid('Body weight must be greater than 0'); }
          if(don <= 0){ return invalid('Donor PCV must be greater than 0'); }
          if([cur,des,don].some(function(x){return x>100;})){ return invalid('PCV values cannot exceed 100%'); }
          if(des <= cur){
            els.volume.innerHTML = '0 <span>mL</span>';
            els.note.textContent = 'Patient already at or above target PCV';
            setState('warn');
            els.msg.textContent = 'Desired PCV is not higher than current PCV — no transfusion volume calculated.';
            els.breakdown.style.display = 'none';
            return;
          }

          var rise = des - cur;
          var volume = w * k * (rise / don);
          var perkg = volume / w;

          els.volume.innerHTML = round(volume) + ' <span>mL</span>';
          els.note.textContent = 'Fresh whole blood to raise PCV from ' + cur + '% to ' + des + '%';

          // overload guidance
          if(perkg > 22){
            setState('warn');
            els.msg.textContent = 'Note: ' + round(perkg,1) + ' mL/kg exceeds the usual ~22 mL/kg guide — reassess dose and watch for volume overload.';
          } else {
            setState('');
          }

          els.rise.textContent = round(rise,1) + ' %';
          els.perkg.textContent = round(perkg,1) + ' mL/kg';
          els.const.textContent = k + ' mL/kg (' + species + ')';
          els.formula.textContent = round(w,1) + ' × ' + k + ' × (' + des + ' − ' + cur + ') / ' + don + ' = ' + round(volume) + ' mL';
          els.breakdown.style.display = 'block';
        }

        function invalid(m){
          els.volume.innerHTML = '— <span>mL</span>';
          els.note.textContent = 'Check your inputs';
          setState('bad');
          els.msg.textContent = m;
          els.breakdown.style.display = 'none';
        }

        function round(n, d){
          d = d || 0;
          var f = Math.pow(10,d);
          return (Math.round(n*f)/f).toString();
        }
    }
  }

  if (!customElements.get("s-blood-transfusion-calculator")) {
    customElements.define(
      "s-blood-transfusion-calculator",
      BloodTransfusionCalculator
    );
  }
})();
